"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _RichTypography = _interopRequireDefault(require("../RichTypography"));

var _excluded = ["children", "contentType", "description", "icon", "link"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (_ref) {
  var breakpoints = _ref.breakpoints,
      typography = _ref.typography;
  return {
    root: _defineProperty({
      flexWrap: "nowrap"
    }, breakpoints.up("md"), {
      flexWrap: "wrap"
    }),
    contentType: {
      paddingTop: typography.pxToRem(14)
    },
    description: {
      paddingTop: typography.pxToRem(24)
    },
    icon: {},
    link: {}
  };
});

function DataSourceContent(_ref2) {
  var children = _ref2.children,
      contentType = _ref2.contentType,
      description = _ref2.description,
      icon = _ref2.icon,
      link = _ref2.link,
      props = _objectWithoutProperties(_ref2, _excluded);

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: "auto",
    md: 12,
    className: classes.icon
  }, icon), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: "auto",
    md: 12,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_RichTypography["default"], {
    variant: "subtitle2",
    color: "textSecondary",
    className: classes.contentType
  }, contentType)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_RichTypography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: classes.description
  }, children || description)), link && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    href: link.href,
    variant: "outlined",
    color: "primary",
    className: classes.link
  }, link.label || link.href))));
}

DataSourceContent.propTypes = {
  children: _propTypes["default"].node,
  contentType: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  icon: _propTypes["default"].node.isRequired,
  link: _propTypes["default"].shape({
    href: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string
  })
};
DataSourceContent.defaultProps = {
  children: undefined,
  description: undefined,
  link: {
    href: "#",
    label: "View More"
  }
};
var _default = DataSourceContent;
exports["default"] = _default;